import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RubricaSearchPRModalComponent } from './rubrica-search-pr-modal';

export const RubricaSearchPRModalModule: string = ng
    .module('rubrica-search-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('rubricaSearchPRModalComponent', RubricaSearchPRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/rubrica-search-pr-modal/rubrica-search-pr-modal.module.ts